module.exports = __webpack_public_path__ + "img/Pista_1634.ebe3fb2d.png";